import React, { useState, useEffect, FC, useCallback } from "react";
import { Button } from "@material-ui/core";
import "./InputField.css";
import {
  OrientationType,
  ResolutionType,
  useScreenStore,
} from "application/contexts/screen/ScreenStore";
import { Keyboard, KeyboardType } from "components/keyboard/Keyboard";

interface InputFieldProps {
  onPressContinuar: (inputValue?: string) => void;
  keyboardType: KeyboardType;
  description: string;
  required?: boolean;
  type?: "CPF" | "PHONE";
  alert?: boolean;
  minInputLength?: number;
  maxInputLength?: number;
  textButtomAlert?: {
    confirm: string;
    cancel: string;
  };
  buttonField?: {
    confirm: string;
    cancel: string;
  };
  onPressCancel?: () => void;
  onPressNo?: () => void;
  hideClear?: boolean;
}

export const InputField: FC<InputFieldProps> = ({
  onPressContinuar,
  keyboardType,
  minInputLength,
  maxInputLength,
  required,
  type,
  description,
  alert,
  onPressCancel,
  onPressNo,
  hideClear,
}) => {
  const { resolution, orientation } = useScreenStore();
  const [inputValue, setinputValue] = useState("");
  const [disableContinuar, setdisableContinuar] = useState(false);
  const [enableTeclado, setenableTeclado] = useState(!alert);

  useEffect(() => {
    if (minInputLength) {
      if (inputValue.length >= minInputLength) {
        setdisableContinuar(false);
      } else {
        setdisableContinuar(true);
      }
    }
  }, [inputValue, minInputLength]);

  const onpressKeyboard = useCallback(
    (key: string) => {
      if (!maxInputLength || inputValue.length < maxInputLength) {
        setinputValue((prev) => prev + key);
      }
    },
    [inputValue.length, maxInputLength]
  );

  const onpressback = () => {
    setinputValue((prev) => prev.substring(0, prev.length - 1));
  };

  const onPressClear = () => {
    setinputValue("");
  };

  const onClickNaoInformar = useCallback(() => {
    setinputValue("");
    if (onPressCancel) {
      onPressCancel();
    }
  }, [onPressCancel]);

  const onClickContinuar = useCallback(() => {
    onPressContinuar(inputValue);
    setinputValue("");
  }, [inputValue, onPressContinuar]);

  const onClickInformar = () => {
    setenableTeclado(true);
  };

  const phoneMask = (Field: string) => {
    let newValue =
      (Field.length > 0 ? "(" : "") +
      Field.substring(0, 2) +
      (Field.length > 2 ? ")" : "") +
      Field.substring(2, 11);
    return newValue;
  };

  return (
    <div className="inputField">
      {!enableTeclado ? (
        <>
          <div className="description-inputField">{description}</div>
          <div className="buttons-inputField">
            <Button
              onClick={onClickNaoInformar}
              className="button-inputField nao-informar-inputField"
            >
              NÃO
            </Button>

            <Button
              onClick={onClickInformar}
              className={"button-inputField continuar-inputField"}
            >
              SIM
            </Button>
          </div>
        </>
      ) : (
        <>
          <div className="description-inputField">{description}</div>

          {type === "PHONE" ? (
            <div className="value-inputField">{phoneMask(inputValue)}</div>
          ) : (
            <div
              className="value-inputField"
              style={{
                fontSize: resolution === ResolutionType.FULL_HD ? 40 : 28,
                padding: resolution === ResolutionType.FULL_HD ? 26 : 18,
              }}
            >
              {inputValue}
            </div>
          )}
          <div
            className="keyboar-container-inputField"
            style={{ width: keyboardType === "numeric" ? "100" : "100%" }}
          >
            <Keyboard
              type={keyboardType}
              onPressBack={onpressback}
              onKeyPress={onpressKeyboard}
              onPressClear={onPressClear}
              hideClear={hideClear}
            />
          </div>

          <div
            className={
              orientation === OrientationType.LANDSCAPE
                ? "landscape-buttons-inputField"
                : "buttons-inputField"
            }
          >
            <Button
              onClick={onClickContinuar}
              disabled={disableContinuar}
              className={
                disableContinuar
                  ? "button-inputField continuar-inputField disabled-continuar-inputField"
                  : "button-inputField continuar-inputField enable-continuar-inputField"
              }
              style={{
                fontSize: resolution === ResolutionType.FULL_HD ? 45 : 36,
              }}
            >
              Confirmar
            </Button>
            {!required && (
              <Button
                onClick={onClickNaoInformar}
                className="button-inputField nao-informar-inputField"
                style={{
                  fontSize: resolution === ResolutionType.FULL_HD ? 45 : 36,
                  marginTop: orientation === OrientationType.LANDSCAPE ? 0 : 16,
                }}
              >
                Não informar
              </Button>
            )}
          </div>
        </>
      )}
    </div>
  );
};
